//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function TheGoodTheBad() {

    return (
        <>

        <p>You were down at the old high horse<br></br>
        Smoking on the leaves of your last torch<br></br>
        Blowing out an ode to the wind <br></br>
        It’s all down to chance if you catch my drift<br></br>
        You made the thunders cry again<br></br>
        Whilst trying to look for a long lost friend<br></br>
        Following you blind and you took me by surprise<br></br>
        Take me back to bedlam for a little taste of heaven<br></br>
        <br></br>
        Angels don’t fly where I come from<br></br>
        Angels don’t fly where I come from<br></br>
        <br></br>
        When you fell down to the earth<br></br>
        Had you been here once before<br></br>
        Cos I swore that I saw you<br></br>
        Breaking the golden rule as a favour<br></br>
        Is there a time that we could have changed<br></br>
        <br></br>
        I get myself another drink<br></br>
        Might be the last you drown me in<br></br>
        Tried not to look you in the eye<br></br>
        Made that mistake a thousand times<br></br>
        You were playing the whole bar section<br></br>
        A game called natural selection<br></br>
        And I’ve got pity on those souls<br></br>
        Forget the world and you lose control<br></br>
        Following you blind and you took me by surprise<br></br>
        Take me back to bedlam for a little taste of heaven<br></br>
        <br></br>
        Angels don’t fly where I come from<br></br>
        Angels don’t fly where I come from<br></br>
        <br></br>
        When you fell down to the earth<br></br>
        Had you been here once before<br></br>
        Cos I swore that I saw you<br></br>
        Breaking the golden rule as a favour<br></br>
        Is there a time that we could have changed<br></br>
        <br></br>
        Counting all the times you're crossing on my mind on the staircase<br></br>
        You're bad love to me<br></br>
        <br></br>
        All this energy is lust in the 3rd degree sue me<br></br>
        You're bad love to me<br></br>
        <br></br>
        Were you ever mine<br></br>
        Were you ever mine<br></br>
        Were you ever mine</p>
        
        </> 
    )
}